import React from "react";
import { ChevronDownIcon, ExclamationCircleIcon } from "@heroicons/react/24/outline";

// Спільний вигляд усіх полів вводу: помітна рамка, контрастний текст,
// яскраве кільце фокусу. text-base (16px) — щоб iOS не зумив сторінку при фокусі.
export const fieldClass = (error, extra = "") =>
  [
    "w-full h-14 rounded-2xl px-4 text-base text-white",
    "bg-slate-900/80 border-2 outline-none transition",
    "placeholder:text-slate-400",
    "focus:border-primary focus:ring-4 focus:ring-primary/25 focus:bg-slate-900",
    error
      ? "border-red-500/80 bg-red-500/10 focus:border-red-500 focus:ring-red-500/25"
      : "border-slate-600 hover:border-slate-500",
    extra,
  ].join(" ");

/**
 * Обгортка поля: підпис, саме поле, текст помилки або підказки.
 * data-error використовує CartPage, щоб прокрутити до першого поля з помилкою.
 */
export const Field = ({ label, error, hint, children, className = "" }) => (
  <div className={className} data-error={!!error}>
    {label && (
      <label className="block mb-2 text-sm font-medium text-slate-300">{label}</label>
    )}
    {children}
    {error && typeof error === "string" ? (
      <p className="mt-1.5 flex items-center gap-1.5 text-sm text-red-400">
        <ExclamationCircleIcon className="w-4 h-4 shrink-0" />
        {error}
      </p>
    ) : (
      hint && <p className="mt-1.5 text-xs text-slate-400">{hint}</p>
    )}
  </div>
);

export const Input = ({ label, error, hint, icon: Icon, className = "", ...props }) => (
  <Field label={label} error={error} hint={hint} className={className}>
    <div className="relative">
      {Icon && (
        <Icon className="w-5 h-5 text-slate-400 absolute left-4 top-1/2 -translate-y-1/2 pointer-events-none" />
      )}
      <input className={fieldClass(error, Icon ? "pl-12" : "")} {...props} />
    </div>
  </Field>
);

export const TextArea = ({ label, error, hint, className = "", rows = 3, ...props }) => (
  <Field label={label} error={error} hint={hint} className={className}>
    <textarea rows={rows} className={fieldClass(error, "h-auto py-3 resize-none leading-relaxed")} {...props} />
  </Field>
);

export const Select = ({ label, error, hint, className = "", children, ...props }) => (
  <Field label={label} error={error} hint={hint} className={className}>
    <div className="relative">
      <select className={fieldClass(error, "appearance-none pr-11 cursor-pointer")} {...props}>
        {children}
      </select>
      <ChevronDownIcon className="w-5 h-5 text-slate-400 absolute right-4 top-1/2 -translate-y-1/2 pointer-events-none" />
    </div>
  </Field>
);
